import IconButton, {
  IconButtonSizes,
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import Popover, { PopoverBody } from '@lib/components/Popover/Popover';

// Matches $zIndexTooltip in _zIndex.scss ("must sit above everything —
// including portaled select menus"). AiFieldAssist can be embedded as a
// rightAdornment inside a Select field with `usePortal` (e.g. Category),
// whose own dropdown menu deliberately renders at z-index 9999 — without
// this override, opening that dropdown would cover this Popover.
const POPOVER_Z_INDEX = 10000;

type Props = {
  body: PopoverBody;
  // Trigger IconButton config. All four states render the same 32x32 Small
  // hover trigger, varying only these props.
  iconButtonType: IconButtonTypes;
  ariaLabel: string;
  icon?: string;
  symbolsOutlined?: boolean;
  isLoading?: boolean;
};

// Shared shell for every AiFieldAssist state: a hover Popover whose trigger is
// a 32x32 Small IconButton at the field's edge. Only the popover body and the
// trigger's icon/type/loading vary between states.
export default function AiFieldAssistPopover({
  body,
  iconButtonType,
  ariaLabel,
  icon,
  symbolsOutlined,
  isLoading,
}: Props) {
  return (
    <Popover
      trigger="hover"
      placement="bottomRight"
      width={354}
      body={body}
      zIndex={POPOVER_Z_INDEX}
    >
      {({ handleToggle }) => (
        <div>
          <IconButton
            icon={icon}
            symbolsOutlined={symbolsOutlined}
            isLoading={isLoading}
            type={iconButtonType}
            size={IconButtonSizes.Small}
            aria-label={ariaLabel}
            onClick={() => handleToggle()}
          />
        </div>
      )}
    </Popover>
  );
}
